import { render, staticRenderFns } from "./TheSearch.vue?vue&type=template&id=8ddef428&"
import script from "./TheSearch.vue?vue&type=script&lang=js&"
export * from "./TheSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ddef428')) {
      api.createRecord('8ddef428', component.options)
    } else {
      api.reload('8ddef428', component.options)
    }
    module.hot.accept("./TheSearch.vue?vue&type=template&id=8ddef428&", function () {
      api.rerender('8ddef428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheSearch.vue"
export default component.exports